export const IMPROVE_VALID_DATA_RATE_GUIDE_URLS: Record<'es' | 'en' | 'pt', string> = {
  es: 'https://soporte.myhotel.cl/es/base-conocimientos/gu%C3%ADa-pr%C3%A1ctica-captura-de-datos-v%C3%A1lidos-y-aumento-de-tasa-de-respuesta',
  en: 'https://soporte.myhotel.cl/en/base-conocimientos/practical-guide-valid-data-capture-and-increasing-response-rate',
  pt: 'https://soporte.myhotel.cl/pt-br/base-conocimientos/guia-pr%C3%A1tica-captura-de-dados-v%C3%A1lidos-e-aumento-de-taxa-de-resposta',
};
